import { render } from "./workshopCameraDialog.vue?vue&type=template&id=3ad77b60&scoped=true"
import script from "./workshopCameraDialog.vue?vue&type=script&lang=js"
export * from "./workshopCameraDialog.vue?vue&type=script&lang=js"

import "./workshopCameraDialog.vue?vue&type=style&index=0&id=3ad77b60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad77b60"]])

export default __exports__